import React, { useState, useEffect } from "react";
import "./videojs.css";
import VideoPlayer from "./VideoPlayer";

const VideoJSPlayerInterview = (props) => {
  const [fileURL, setFileUrl] = useState(props.fileURL);
  const [signedUrl, setSignedUrl] = useState("");
  const [autoplay, setAutoplay] = useState(props.isAutoplay ?? true);

  useEffect(() => {
    setFileUrl(props.fileURL);
    if (props.playExternalVideo) setSignedUrl(props.fileURL);
  }, [props.fileURL]);

  const videoJsOptions = {
    autoplay: autoplay,
    controls: true,
    controlBar: {
      playToggle: false,
      captionsButton: false,
      chaptersButton: false,
      subtitlesButton: false,
      remainingTimeDisplay: false,
      fullscreenToggle: true,
    },
    responsive: true,
    fluid: true,
    poster: props.image ?? "",
    sources: [
      {
        src: fileURL,
        // type: `video/${extension}`,
      },
    ],
  };

  return (
    <div>
      <VideoPlayer
        options={videoJsOptions}
        className="vjs-player-interview"
      ></VideoPlayer>
    </div>
  );
};

export default React.memo(VideoJSPlayerInterview);
